import { render, staticRenderFns } from "./contentus.vue?vue&type=template&id=dad647f2"
import script from "./contentus.vue?vue&type=script&lang=js"
export * from "./contentus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports